import {useMutation, useQueryClient} from '@tanstack/react-query'
import api from 'src/services/api'
import {BindFaceDTO} from 'src/services/api/endpoints/FacialRecognitionEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

export default function useEventsReport() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (data: BindFaceDTO) => {
      return await api.facialRecognition.bindFace(data)
    },
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: [QueryKeyEnum.FACES]})
      queryClient.invalidateQueries({queryKey: [QueryKeyEnum.FACE_LISTS]})
      queryClient.invalidateQueries({queryKey: [QueryKeyEnum.FACE_DETECTIONS]})
    },
  })

  return mutation
}
